<template>
  <div>
    <b-table
      :data="filteredUsers"
      :checked-rows.sync="selectedUsers"
      searchable
      checkable
      paginated
      pagination-simple
      sortable
      :per-page="30"
      pagination-position="bottom"
      sort-icon="arrow-up"
      sort-icon-size="is-small"
      default-sort-direction="asc"
      default-sort="firstName"
      :is-row-checkable="row => row.assessmentStates.length <= 2"
      ref="addEnglish"
      custom-row-key="_id"
    >
      <template>
        <b-table-column
          field="firstName"
          label="First Name"
          width="30"
          sortable
          searchable
          v-slot="props"
        >
          <div :class="selectedUsers.includes(props.row) ? 'bold-text' : ''">
            {{ props.row.firstName }}
          </div>
        </b-table-column>
        <b-table-column
          field="lastName"
          label="Last Name"
          width="30"
          sortable
          searchable
          v-slot="props"
        >
          <div>
            {{ props.row.lastName }}
          </div>
        </b-table-column>
        <b-table-column
          field="email"
          label="Email"
          width="35"
          sortable
          searchable
          v-slot="props"
        >
          <div>
            {{ props.row.email }}
          </div>
        </b-table-column>
        <b-table-column field="grade" label="Grade" width="5" v-slot="props">
          <div>
            {{ props.row.grade }}
          </div>
        </b-table-column>
        <b-table-column field="class" label="Class" width="5" v-slot="props">
          <div>
            {{ props.row.grade }}
          </div>
        </b-table-column>
        <b-table-column field="updatedAt" label="Updated" width="10" sortable v-slot="props">
          <div>
            {{ props.row.updatedAt.slice(0, -5).replace("T", " ") }}
          </div>
        </b-table-column>
        <b-table-column field="subjects" label="Subjects" width="30" v-slot="props">
          <div>
            {{ userSubjects(props.row) }}
          </div>
        </b-table-column>
      </template>
    </b-table>
    <b-button
      id="tableBtn"
      @click="addSubject('ENGLISH')"
      class="tag is-primary"
      size="is-medium"
      >Add English Assessment</b-button
    >
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ToastProgrammatic as Toast } from "buefy";
import _cloneDeep from "lodash/cloneDeep";

export default {
  props: {},
  components: {},
  data() {
    return {
      selectedUsers: []
    };
  },
  computed: {
    ...mapGetters({
      filteredUsers: "globalStore/getFilteredList"
    })
  },
  methods: {
    ...mapActions({
      addEnglishSubject: "globalStore/addEnglishSubject",
      loading: "SET_SCREEN_LOADING"
    }),
    async addSubject(subject) {
      if (this.selectedUsers && this.selectedUsers.length > 0) {
        this.loading(true);
        let subjectSuccess = 0;
        let successUserIds = [];
        for (const element of this.selectedUsers) {
          const subjectExists = element.assessmentStates.find(
            o => "ENGLISH" === o.subject
          );
          if (typeof subjectExists === "undefined") {
            let results = await this.addEnglishSubject(element._id);
            subjectSuccess++;
            successUserIds.push(element._id);
          }
        }
        this.loading(false);
        //show msg
        let msgType = "is-success";
        if (subjectSuccess === 0) {
          msgType = "is-danger";
        }
        this.$buefy.toast.open({
          message: `English assessment added to ${subjectSuccess} of ${this.selectedUsers.length} selected learners.`,
          type: msgType,
          duration: 4000
        });
        //update the ui of the affected rows
        for (const learner of this.$refs.addEnglish.data) {
          let selectedUser = this.selectedUsers.find(
            o => learner._id === o._id
          );
          if (selectedUser && successUserIds.includes(learner._id)) {
            learner.assessmentStates.push({
              subject: "ENGLISH",
              type: "ENGLISH_JUNIOR_HIGH"
            });
          }
        }
        //reset the selected items
        this.selectedUsers = [];
        this.$refs.addEnglish.selected = [];
        return true;
      }
      return false;
    },
    userSubjects(user) {
      const subjects = user.assessmentStates.map(function(value) {
        return value.subject;
      });

      return subjects.reverse().join(" & ");
    }
  },
  mounted() {}
   
};
</script>
